import { render, staticRenderFns } from "./OAuthRedirectPage.vue?vue&type=template&id=1e13615c"
import script from "./OAuthRedirectPage.vue?vue&type=script&lang=js"
export * from "./OAuthRedirectPage.vue?vue&type=script&lang=js"
import style0 from "./OAuthRedirectPage.vue?vue&type=style&index=0&id=1e13615c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports